( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function PpdViewCtrl ( $scope, ppdFactory ) {
		var self = this;

		function updateData () {
			self.attachedData    = ppdFactory.getAttachedPDs();
			self.recommendedData = ppdFactory.getRecommendedPDs();
		}

		function initListeners () {
			$scope.$on( 'ppd:add', function ( event, item ) {
				ppdFactory.attachData( item );
				updateData();
			} );

			$scope.$on( 'ppd:remove', function ( event, item ) {
				ppdFactory.detachData( item );
				updateData();
			} );

			$scope.$on( 'ppd:update', function ( event, item ) {
				ppdFactory.updateData( item );
				updateData();
			} );
		}

		function activate () {
			self.attachedData    = angular.copy( ppdFactory.getAttachedPDs() );
			self.recommendedData = angular.copy( ppdFactory.getRecommendedPDs() );
			initListeners();
		}

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'PpdViewCtrl', PpdViewCtrl );

	PpdViewCtrl.$inject = [ '$scope', 'ppdFactory' ];
} )( );
